import { mapActions, mapGetters, mapState } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import marketBiggestGainsElement from '@/components/market/market-biggest-gains-element/market-biggest-gains-element.vue';
import { range } from 'lodash';

const REFRSEH_ENABLED = true;
const REFRESH_INTERVAL = 10 * 60 * 1000;

export default {
  mixins: [
    contentLoaderMixin,
    loaderMixin,
  ],
  components: {
    swiper,
    swiperSlide,
    marketBiggestGainsElement,
  },
  props: {
    headerId: {
      type: Number,
      default: 0,
    },
    extended: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: 0,
      interval: null,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: (swp) => {
          this.activeIndex = swp.activeIndex;
        },
      },
    };
  },
  methods: {
    ...mapActions('browse', [
      'getTwentyFourGains', 'getTwentyFourLoss', 'getWeekGains', 'getWeekLoss',
    ]),
    prevSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slidePrev();
    },
    nextSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slideNext();
    },
    fetchData() {
      const promises = [
        this.getTwentyFourGains({}),
        this.getTwentyFourLoss({}),
        this.getWeekGains({}),
        this.getWeekLoss({}),
      ];

      this.loaderAdd();
      Promise.all(promises)
        .then(() => {
          this.isComponentReady = true;
          this.loaderRemove();
        })
        .catch(() => this.loaderRemove());
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapState('browse', ['twentyFourGains', 'twentyFourLoss', 'weekGains', 'weekLoss']),
    classModifiers() {
      return {
        'market-biggest-gains': true,
        'market-biggest-gains--extended': this.extended,
      };
    },
    dummyComponents() {
      if (this.isLayoutMobile) return range(0, 1);
      const num = this.extended ? 4 : 2;
      return range(0, num);
    },
    items() {
      const results = [];
      if (this.isLayoutDesktop) {
        if (this.twentyFourGains.length) results.push(this.twentyFourGains[0]);
        if (this.twentyFourLoss.length) results.push(this.twentyFourLoss[0]);
        if (this.extended) {
          if (this.weekGains.length) results.push(this.weekGains[0]);
          if (this.weekLoss.length) results.push(this.weekLoss[0]);
        }
      } else {
        if (this.twentyFourGains.length) results.push(this.twentyFourGains);
        if (this.twentyFourLoss.length) results.push(this.twentyFourLoss);
        if (this.extended) {
          if (this.weekGains.length) results.push(this.weekGains);
          if (this.weekLoss.length) results.push(this.weekLoss);
        }
      }
      return results;
    },
    isPrevArrowDisabled() {
      return this.activeIndex === 0;
    },
    isNextArrowDisabled() {
      return this.items.length === 0 || this.activeIndex === 3;
    },
    prevArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--left': true,
        // 'market-biggest-gains__swiper-arrows__arrow--disabled': this.isPrevArrowDisabled,
      };
    },
    nextArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--right': true,
        // 'market-biggest-gains__swiper-arrows__arrow--disabled': this.isNextArrowDisabled,
      };
    },
    shouldShowMobileSlider() {
      return this.items.length > 0 && !this.isLayoutDesktop;
    },
    shouldShowDesktopList() {
      return this.items.length > 0 && this.isLayoutDesktop;
    },
  },
  mounted() {
    this.fetchData();
    if (REFRSEH_ENABLED) {
      this.interval = setInterval(() => {
        this.fetchData();
      }, REFRESH_INTERVAL);
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-biggest-gains/market-biggest-gains.js